const {fieldPathJoinGetter} = require("../../utils/kp3Utils");

export const entity = {
    name: "FamilyAxis",
    facets: ["codeName", "translatedField"],
    fields: [
        {path: "useInScope", type: "boolean", default: false},
        fieldPathJoinGetter({path: "tFullName", fieldPath: ["code", "tName"]})
    ]
}

export const module_ = {
    object: "FamilyAxis",
    tKey: "mTitle_familyAxis",
    category: {
        path: "referential",
        icon: 'server'
    },
    defaultSortBy: "name",
    defaultSortDirection: "ASC",
    // facets: [{name: "codeName", editableCode: false}],
    viewMap: {
        dt: [
            "code",
            {path: "name", translateName: true}
        ],
        form: [
            {path: "code", editable: false},
            {path: "name", type: "textarea"},
            "useInScope"
        ]
    },
    removable: false
}
